<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogScrollContent size="lg">
      <DialogHeader>
        <DialogTitle>
          {{ $t("Availability") }}
        </DialogTitle>
      </DialogHeader>

      <EquipmentInfo v-if="equipment" :item="equipment" class="mb-3" />

      <p class="text-muted small">
        {{ $t("The period is chosen at the date step and cannot be changed here.") }}
      </p>

      <EquipmentCalendar
        v-if="equipment"
        :key="equipment.id"
        :timezone="timezone"
        :booking="{ equipment }"
        readonly
      >
      </EquipmentCalendar>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import EquipmentCalendar from "@/components/booking/EquipmentCalendar.vue";
import EquipmentInfo from "@/components/equipment/EquipmentInfo.vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * Shows when one item is taken, so a wanted product can inform the period the user then sets at
 * the date step. Purely consultative: adopting a range from here would bypass the tour's booking
 * times and advance rules that the date step applies.
 */
defineProps({
  open: {
    type: Boolean,
    default: false
  },
  equipment: {
    type: Object,
    default: null
  },
  timezone: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["update:open"]);
</script>
